import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../utils/api";
import { Organization } from "../../../@types/organization";
import axiosInstance from "../../../utils/axiosConfig";
export const createOrganization = createAsyncThunk(
  "organization/create",
  async (formData: Organization, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.post(`${api.baseURL}organization`, formData);
      return data as Organization;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
